import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import InputDialog from "./InputDialog";
import TopAppBar from "./TopAppBar";
import Footer from "./Footer";

const useStyles = makeStyles({
  root: {
    display: "flex",
    height: "calc(100vh - 64px)",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonContainer: {
    marginTop: 20,
  },
  button: {
    margin: "0 10px",
  },
});

const Home = () => {
  const classes = useStyles();
  return (
    <div>
      <TopAppBar />
      <div className={classes.root}>
        <Grid container direction="column" alignItems="center">
          <InputDialog />
          <div className={classes.buttonContainer}>
            <Button
              component={Link}
              to="/triton"
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Triton Converter
            </Button>
            <Button
              component={Link}
              to="/translations"
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Translations Manager
            </Button>
          </div>
        </Grid>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
